import FilterContainer from "./components/FilterContainer"
import { useContext } from "react";
import SquareReport from "./components/SquareReport";
import TableReportIndividual from "./components/TableReportIndividual"
import ReportContext  from "../../context/ReportsContext/ReportContext";
// @ts-ignore: allow importing CSS files without type declarations
import "./css/FilterConteiner.css";


const ReportIndividual = ({loading}:any) => {
const { state } = useContext(ReportContext); 
  return (
    <>
    {(loading === true) ?
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
        :
        <div className="contenedorReportIndividual">
        {state?.reportPreviewData?.viewFilter?
         <FilterContainer  />:<></>
         }
         {
          state?.reportPreviewData?.viewSquare !== true ? 
          <TableReportIndividual/>         
           :
           <SquareReport report= {state?.reportPreviewData?.report }/>           
         }         
       </div>     
     }  
       
    </>    
  )
}

export default ReportIndividual
